export default "__VITE_PUBLIC_ASSET__7d2c78e4__"